import type { FaireProductEntity } from "../../entity_types/product";

export const p_8pkkumhtwe: FaireProductEntity = {
  token: "p_8pkkumhtwe",
  type: "product",
  name: "Tomato-do List Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/bf2278b2cc6f7f3f2274352a40bd1a0405acddea89463166c6eb53529d03d8d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6b7b6339873c25d89c4c86788e5c8d4a4ecd1dd5d5ebe05466e82da706f99f7b.jpeg",
    "https://cdn.faire.com/fastly/3754a8c19d9ae1fdeb165042ca1f2595f2ace57c64b3d2de20c52b8692a349d0.jpeg"
  ],
  priceDollars: 4,
  description: "Serve up reminders, grocery lists, recipes & more on our Tomato-do Sticky Notes. Great for getting organized and bookmarking cookbooks. \n\nGood to know: \n\n * Iconic OG Tomato design! \n * Stick & restick anywhere. \n * Measures 3in x 3in \n * 100% Recyclable ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:06.574Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
